import styled from '@emotion/styled';

export const ButtonsSection = styled.div`
  display: flex;
  gap: 5px;
`;
